import React from "react"
import { Trans } from "react-i18next";
export default function addSuperScript(text: string) {

    return (
        <Trans defaults={text}>
            <sup></sup>
            <i></i>
        </Trans>
    )
}